import { c as _c } from "react/compiler-runtime";
// Copied from (main_app)/lead-gen-profiles/_hooks/useDebounce.js
import { useEffect, useState } from "react";
export const useDebounce = (value, t0) => {
  const $ = _c(4);
  const delay = t0 === undefined ? 500 : t0;
  const [debouncedValue, setDebouncedValue] = useState(value);
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== value) {
    t1 = () => {
      const timer = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => clearTimeout(timer);
    };
    t2 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return debouncedValue;
};